import { render, staticRenderFns } from "./CatalogsView.vue?vue&type=template&id=37e330a5&"
import script from "./CatalogsView.vue?vue&type=script&lang=js&"
export * from "./CatalogsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports